import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import ReactTooltip from 'react-tooltip'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'

export default class OptionRow extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false
    }
    this.queryChanged = this.queryChanged.bind(this)
    this.onSoundChange = this.onSoundChange.bind(this)
  }

  queryChanged(e) {
    let value = ''
    let temp = e.target.value.trim()
    if (temp.length >= 3)
      value = temp
    this.props.onQueryChanged(value)
  }

  open() {
    window.analytics.track('Pressed filter button')
    this.setState({showModal: true})
  }

  close(e) {
    if (e) e.preventDefault()
    this.setState({showModal: false})
  }

  onSoundChange(e) {
    this.props.onChange('sound', e.target.checked)
  }

  render() {
    let bookmakerListOptions = Object.keys(this.props.bookmakerLists).map(key => {
      let list = this.props.bookmakerLists[key]
      return {
        text: list.name,
        value: key
      }
    })
    return (
      <div className='option-row col-xs-12'>
        <div className='input-group search'>
          <span className='input-group-addon'>
            <i className='fa fa-search fa-lg'></i>
          </span>
          <input type='text' className='form-control' placeholder='Search' onChange={this.queryChanged} />
        </div>
        <div className='settings'>
          <i
            className='fa fa-cog fa-lg'
            data-tip='Change filters for edgebets'
            data-for='option-row'
            onClick={this.open.bind(this)}
            >
          </i>
        </div>
        <ReactTooltip place='bottom' effect='solid' id='option-row' />
        <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>Edgebet filters</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form className='form-horizontal'>
              <FilterFormGroup
                label="Bookmaker list"
                options={bookmakerListOptions}
                stateKey='bookmakerList'
                onChange={this.props.onChange}
                value={this.props.bookmakerList}
              />
              <FilterFormGroup
                label="Time frame"
                options={[{value: 1, text: 'Next 12 hours'}, {value: 0, text: 'Next 2 days'}]}
                stateKey='next12hours'
                onChange={this.props.onChange}
                value={this.props.next12hours}
              />
              <FilterFormGroup
                label="Odds & edge"
                options={[{value: 1, text: 'Low risk'}, {value: 0, text: 'All edges'}]}
                stateKey='lowRisk'
                onChange={this.props.onChange}
                value={this.props.lowRisk}
              />
              <FilterFormGroup
                label="Leagues"
                options={[{value: 1, text: 'Recommended'}, {value: 0, text: 'All leagues'}]}
                stateKey='recommendedLeagues'
                onChange={this.props.onChange}
                value={this.props.recommendedLeagues}
              />
              <div className='form-group'>
                <label className='col-xs-3 control-label'>Sound </label>
                <div className='col-xs-9 react-toggle-form-group'>
                  <Toggle
                    defaultChecked={this.props.sound}
                    onChange={this.onSoundChange}
                  />
                </div>
              </div>
              <div className='form-group'>
                <div className='col-xs-9 col-xs-offset-3'>
                  <button type='button' className='btn btn-primary' onClick={this.close.bind(this)}>I'm done</button>
                  <button type='button' className='btn btn-danger pull-right' onClick={this.props.clearHiddenEdges}>Clear all hidden edges</button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

class FilterFormGroup extends Component {

  onChange(key, e) {
    e.preventDefault()
    let val = e.target.value
    if (this.props.stateKey !== 'bookmakerList')
      val = +val
    this.props.onChange(key, val)
  }

  shouldComponentUpdate(nextProps) {
    return this.props.value !== nextProps.value
  }

  render() {
    return (
      <div className='form-group'>
        <label className='col-xs-3 control-label'>{ this.props.label }</label>
        <div className='col-xs-9'>
          <select className='form-control' value={this.props.value } onChange={this.onChange.bind(this, this.props.stateKey)}>
            { this.props.options.map(option => {
              return <option key={option.value} value={option.value}>{ option.text }</option>
            })}
          </select>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/edgebets/OptionRow.js
 **/